<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t('Detalhes da Atividade') }}</h1>

    <loading-animation :active.sync="loading" :is-full-page="false"
      :opacity="1" color="#5895FF" />

    <div v-if="erro" class="mb-3">
      <b-alert show variant="danger">{{ erro }}</b-alert>
      <b-button type="button" variant="secondary" size="sm" @click="$router.go(-1)">Voltar</b-button>
    </div>

    <div v-else-if="item && item.id && !loading" class="row">
      <div class="col-md-12">
        <print-content>
          <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
            <tbody>
              <tr>
                <td>ID: <strong>{{ item.id }}</strong></td>
                <td>PROTOCOLO: <strong>{{ item.protocolo }}</strong></td>
                <td>CADASTRADO: <strong>{{ formatDate(item.created_at) }}</strong></td>
                <td>ATUALIZADO: <strong>{{ formatDate(item.updated_at) }}</strong></td>
              </tr>
              <tr>
                <td colspan="2">USUÁRIO: <strong>{{ acolhimento.nome_acolhido || '-' }}</strong></td>
                <td>UNIDADE: <strong>{{ nomeUnidade }}</strong></td>
                <td>STATUS: <b>{{ item.status }}</b></td>
              </tr>
              <tr>
                <td colspan="2">ATIVIDADE: <strong>{{ item.atividade }}</strong></td>
                <td>OBJETIVO: <b>{{ item.objetivo }}</b></td>
                <td>LOCAL: <b>{{ item.local }}</b></td>
              </tr>
            </tbody>
          </table>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <b-button type="button" variant="default" class="mr-2" title="Voltar" @click="$router.go(-1)">
                <i class="mdi mdi-arrow-left"></i>
              </b-button>
              <b-button type="button" variant="primary" title="Imprimir" @click="print">
                <i class="mdi mdi-printer"></i>
              </b-button>
            </div>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>

<script>
import { API, formatarDataHora, mensagemErro, imprimirBoxPrint, limparImpressaoAtividade } from './apoioAtividadesCrianca';

export default {
  name: 'ShowAtividadeCrianca',
  data() {
    return { item: null, loading: true, erro: '', requisicao: 0 };
  },
  computed: {
    acolhimento() { return (this.item && this.item.acolhimento) || {}; },
    nomeUnidade() {
      const unidade = this.acolhimento.unidade || {};
      return unidade.nome || unidade.descricao || unidade.name || '-';
    },
  },
  watch: {
    '$route.params.id': { immediate: true, handler() { this.getItem(); } },
  },
  beforeDestroy() {
    this.requisicao += 1;
    limparImpressaoAtividade();
  },
  methods: {
    formatDate(valor) {
      if (!valor) return '-';
      if (/^\d{4}-\d{2}-\d{2}$/.test(String(valor))) return formatarDataHora(valor);
      const date = new Date(String(valor).replace(' ', 'T'));
      return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('pt-BR');
    },
    async getItem() {
      const requisicao = ++this.requisicao;
      this.loading = true;
      this.erro = '';
      this.item = null;
      try {
        const response = await axios.get(`${API}/imprimir/${this.$route.params.id}`);
        if (requisicao === this.requisicao) this.item = response.data;
      } catch (erro) {
        if (requisicao !== this.requisicao) return;
        this.erro = mensagemErro(erro, 'Erro ao buscar os dados da atividade.');
        if (this.$bvToast && typeof this.$bvToast.toast === 'function') {
          this.$bvToast.toast(this.erro, { title: 'Erro', variant: 'danger', solid: true });
        }
      } finally {
        if (requisicao === this.requisicao) this.loading = false;
      }
    },
    print() {
      if (!this.loading && this.item) imprimirBoxPrint(this);
    },
  },
};
</script>

<style>
@media screen {
  #print[data-acolhimento-atividade="1"] {
    display: none;
  }
}

@media print {
  body.imprimindo-atividade-acolhimento * {
    visibility: hidden;
  }

  body.imprimindo-atividade-acolhimento #print,
  body.imprimindo-atividade-acolhimento #print * {
    visibility: visible;
  }

  body.imprimindo-atividade-acolhimento #print {
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  body.imprimindo-atividade-acolhimento #print .no-print {
    display: none !important;
  }
}
</style>
